const languages = {
  values: [
    {
      id: 1,
      code: 'fa',
      text: 'fa',
      // textArray: ()=>findText(1),
      // faText: findText(1)?.[0],
      // enText: findText(1)?.[1],
      // arText: findText(1)?.[2]
    },
    {
      id: 2,
      code: 'en',
      text: 'en',
      // textArray: ()=>findText(2),
      // faText: findText(2)?.[0],
      // enText: findText(2)?.[1],
      // arText: findText(2)?.[2]
    },
    {
      id: 3,
      code: 'ar',
      text: 'ar',
      // textArray: ()=>findText(3),
      // faText: findText(3)?.[0],
      // enText: findText(3)?.[1],
      // arText: findText(3)?.[2]
    },
  ],
};
export default languages;
